export const workRequestPermissions = {
    FULL_ACCESS: {
        key: 'work_request.full_access',
        name: 'Work Request Full Access',
        description: 'Allows viewing and triggering work request actions'
    }
}
